export default __webpack_public_path__ + "static/media/plant-add.35fe2c0f.svg";